import { PropsWithChildren, useMemo } from "react";

import {
  RoleProfileActionButtonsContext,
  RoleProfileActionButtonsContextType
} from "./role_profile_action_buttons_context";

export type RoleProfileActionButtonsProviderProps = RoleProfileActionButtonsContextType;

export const RoleProfileActionButtonsProvider = ({
  children,
  ...props
}: PropsWithChildren<RoleProfileActionButtonsProviderProps>) => {
  const contextValue = useMemo(() => ({ ...props }), [props]);

  return (
    <RoleProfileActionButtonsContext.Provider value={contextValue}>
      {children}
    </RoleProfileActionButtonsContext.Provider>
  );
};
